import { render, staticRenderFns } from "./Logincopy.vue?vue&type=template&id=9a151ecc&scoped=true&"
import script from "./Logincopy.vue?vue&type=script&lang=js&"
export * from "./Logincopy.vue?vue&type=script&lang=js&"
import style0 from "./Logincopy.vue?vue&type=style&index=0&id=9a151ecc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a151ecc",
  null
  
)

export default component.exports